<template>
    <div>
        <MenuStorage/>
        <Storage/>
    </div>
</template>

<script>
    import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage.vue";
    import Storage from "@/components/admin/stock/storage/Storage.vue";
    export default {
        name: "MainStorage",
        components: {Storage, MenuStorage}
    }
</script>

<style scoped>

</style>
